import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

// Streams aren't replayed to a suspended tab (Safari parks the page and its
// cable), so state flips broadcast while the tab slept never arrive. When the
// tab has been hidden long enough to have plausibly missed one, reload to
// catch up. Short alt-tabs stay untouched.
const STALE_MS = 60_000

export default class extends Controller {
  connect() {
    this.track = () => {
      if (document.hidden) {
        this.hiddenAt = Date.now()
      } else if (this.hiddenAt && Date.now() - this.hiddenAt > STALE_MS) {
        Turbo.visit(window.location.href, { action: 'replace' })
      }
    }
    document.addEventListener('visibilitychange', this.track)
  }

  disconnect() {
    document.removeEventListener('visibilitychange', this.track)
  }
}
